(function($) {

    

    if($('.js-auth-check').length) {

        // read query string from url and get the token
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const token = urlParams.get('token');

        let data = {
            'action': 'auth_state',
            'nonce': ajax_global.nonce,
            'token': token
        };
        $.ajax({
            url: '/wp-admin/admin-ajax.php',
            data: data,
            type: 'POST',
            success: function (data) {
                if (data) {
                    data = jQuery.parseJSON(data);
                    if(data.success == false) {
                        $('<div class="container-full"><div class="auth-alert alert-danger" role="alert">' + data.message + '</div></div>').insertAfter('.site-header');
                    } else {
                        //set this for the initial page load so our link watcher for pipevet.com links can use it.
                        document.cookie = `pipeVetToken=${data.data.pipevet_token}; path=/; max-age=28800; samesite=strict; secure`;
                        $('.auth-menu').append(data.html);
                        $('.auth-menu .btn-primary-sm').remove();
                        // update pipeVetLinks...
                        window.pipeVetLinkUpdater();
                    }
                    $('.js-auth-check').removeClass('js-auth-check');
                } else {
                    console.log('No data');
                }
            }
        });
    }
    
    // function for updating pipeVet links with the token
    window.pipeVetLinkUpdater = function() {
        // read the pipeVetToken from the cookie
        const cookieValue = document.cookie.split('; ').find(row => row.startsWith('pipeVetToken='))?.split("=")[1];

        // If the token is not set, work like normal.
        if (typeof cookieValue === 'undefined' || cookieValue === null) {
            console.log('No token, skipping link update.');
            return;
        }

        console.log('updating links...');

        // If the token is set, append it to the URL.
        $('a[href*="pipevet.com"]').each(function() {
            const href = $(this).attr('href');

            if(href.includes('?token=')) {
                return; // Skip if the token is already present
            }
            const newHref = href.includes('?') ? `${href}&token=${cookieValue}` : `${href}?token=${cookieValue}`;
            $(this).attr('href', newHref);
        });
    };


    // Call the function on page load
    $(document).ready(function() {
        window.pipeVetLinkUpdater();
    });

    
})(jQuery); 

